import equipment from './equipment'
import expertise from './expertise'
import licenseType from './license-type'
import licenseCategory from './license-category'

export default {
  name: 'BaseInfoCourier',
  path: 'courier',
  meta: {
    label: 'courier',
    auth: 'courier'
  },
  component: {
    name: 'Courier',
    render(c) {
      return c('router-view')
    }
  },
  children: [equipment, expertise, licenseCategory, licenseType]
}
